import React, { useEffect, useState } from "react";

const Dropdown = ({
  id,
  title,
  options,
  setValueChange,
  customClassName,
  changeListener,
  displayClearButton,
  disabled = false,
}) => {
  const resetDropdown = (id) => {
    const selectElement = document.getElementById(id);
    if (selectElement) {
      selectElement.selectedIndex = 0;
      setValue("");
      setToggled(false);
      localStorage.setItem(id, JSON.stringify(""));
    }
  };
  const [toggled, setToggled] = useState(false);
  const [value, setValue] = useState("");

  useEffect(() => {
    if (value === null) {
      resetDropdown(id);
    } else {
      localStorage.setItem(id, JSON.stringify(value));
    }
  }, [value, id]);

  useEffect(() => {
    resetDropdown(id);
  }, [id, changeListener]);

  return (
    <div style={{ marginTop: 10 }}>
      <select
        id={id}
        disabled={disabled}
        className={`form-control ${customClassName || ""}`}
        style={{ paddingTop: 16, paddingBottom: 16 }}
        onChange={(e) => {
          const selectedValue = e.currentTarget.value;
          setToggled(true);
          setValue(selectedValue);
          if (setValueChange) {
            setValueChange(selectedValue);
          }
        }}
      >
        <option value="" disabled selected>
          {title}
        </option>
        {options.map((opt, index) => (
          <option key={index} value={opt.value}>
            {opt.title}
          </option>
        ))}
      </select>
      {toggled && (
        <label className="text-muted" style={{ fontSize: 12 }}>
          {title}
        </label>
      )}
      {displayClearButton && (
        <button
          className="btn btn-sifar-filled"
          style={{
            position: "absolute",
            right: 19,
            transform: "translateY(-90%)",
            marginTop: "-13.5px",
          }}
          onClick={() => {
            setValue(null);
            if (setValueChange) {
              setValueChange(null);
            }
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Dropdown;
